<template>
    <v-btn
        :color="thin ? undefined : color"
        :block="block"
        :style="style"
        :class="{'zoezi-button-thin': thin}"
        :outlined="thin || outlined"
        :loading="loading"
        :large="large"
        :x-large="xLarge"
        :disabled="disabled"
        :type="type"
        v-on="$listeners"
        :elevation="elevation"
        :href="href"
        :to="to"
        :target="target"
    >
        <slot name="default" v-if="$scopedSlots.default" />
        <template v-else>
            <v-icon left v-if="icon && !right">{{icon}}</v-icon>
            <span v-zoezi-editable="{prop: 'text', html: false, multiline: false}">{{text}}</span>
            <v-icon right v-if="icon && right">{{icon}}</v-icon>
        </template>
    </v-btn>
</template>

<script>
export default {
    name: 'zoezi-button',

    zoezi: {
        title: 'Button',
        icon: 'mdi-gesture-tap-button'
    },

    props: {
        text: {
            title: 'Button text',
            type: String,
            default: () => window.$translate('Click here')
        },
        link: {
            title: 'Link',
            type: Object,
            fulltype: 'link'
        },
        color: {
            title: 'Color',
            type: String,
            fulltype: 'color',
            default: 'primary'
        },
        textColor: {
            title: 'Text color',
            type: String,
            fulltype: 'color',
            default: 'primarytext'
        },
        block: {
            title: 'BLOCK',
            type: Boolean,
            default: false
        },
        thin: {
            title: 'Thinner text and outlined',
            type: Boolean,
            default: false,
            global: true
        },
        outlined: {
            title: 'Outlined',
            type: Boolean,
            default: false
        },
        icon: {
            title: 'Icon',
            type: String,
            fulltype: 'icon'
        },
        right: {
            title: 'Icon to the right',
            type: Boolean,
            default: false
        },
        radius: {
            title: 'Corner radius',
            type: String,
            fulltype: 'csssize',
            global: true
        },
        elevation: {
            title: 'Elevation',
            type: Number,
            typeinfo: {
                min: 0,
                max: 24
            },
            global: true
        },
        loading: {

        },
        disabled: {

        },
        type: {

        },
        large: {
        },
        xLarge: {
        }
    },

    computed: {
        style() {
            let style = {};
            if (!this.disabled) {
                style.color = this.$root.colorToHex(this.textColor) + ' !important';
                if (this.thin) {
                    style['background-color'] = this.$root.colorToHex(this.color);
                }
            }

            style['border-radius'] = this.radius;

            return style;
        },
        href() {
            if (this.$root.edit) {
                return null;
            }
            return this.link?.href;
        },
        to() {
            if (this.$root.edit) {
                return null;
            }
            if (this.link) {
                if (this.link.href) {
                    return null;
                }
                if (this.link.page) {
                    if (this.link.anchor) {
                        return this.link.page + '#' + this.link.anchor;
                    }
                    return this.link.page;
                }
            }

            return null;
        },
        target() {
            if (this.link && this.link.href && this.link.newTab) {
                return '_blank';
            }
            return null;
        }
    }
}
</script>
